import UserGeodataCRUDActions from '../actions/UserGeodataCRUDActions';
import { UserGeodataModel } from '../model/UserGeodataModel';

type ActionType = {
  type: string;
  payload: UserGeodataModel;
};

const initialState = {};

export const userGeodata = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case UserGeodataCRUDActions.retrieveData:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
